import styled, { css } from 'styled-components';

export const StyledTable = styled.div`
    display: grid;
`;

export const StyledRow = styled.div<{ $hasServerMatch?: boolean }>`
    display: grid;
    border-bottom: 1px solid grey;
    align-items: center;
    grid-template-columns: 2fr 5fr 1fr 2fr 1fr 50px;
    gap: 4px;
    padding: 0 15px;
    ${({ $hasServerMatch }) =>
        $hasServerMatch &&
        css`
            border: 2px solid green;
            border-radius: 3px;
        `}
`;
export const StyledCell = styled.div<{ $hasServerMatch?: boolean }>`
    ${({ $hasServerMatch }) =>
        $hasServerMatch &&
        css`
            font-size: 40px;
        `}
    ul {
        padding: 5px;
        li {
            padding: 2px;
        }
    }
`;

export const StyledHeader = styled.div`
    border-bottom: 1px solid white;
    font-weight: 700;
`;
